import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { appConfigReducer } from './common/appConfigReducer';
import { commonReducer } from "./commonReducer";
import { coSoReducer } from "./coSoReducer";
import { namHocReducer } from "./namHocReducer";
import { truongReducer } from "./truongReducer";

const reducers = combineReducers({
    auth: authReducer,
    common: commonReducer,
    appConfig: appConfigReducer,
    // legacy reducers (JS cũ)
    truong: truongReducer as any,
    coSo: coSoReducer as any,
    namHoc: namHocReducer as any,
})

export default reducers
export type RootState = ReturnType<typeof reducers>